export const ADMIN_SECTIONS = [
  {
    id: 'intro',
    label: 'Intro Media',
    icon: '◈',
    title: 'Intro Media',
    subtitle: 'Opening video or logo, social links, and Contact Us details.',
  },
  {
    id: 'products',
    label: 'Products',
    icon: '◇',
    title: 'Products',
    subtitle: 'Create catalogue items with auto NYVM product codes.',
  },
  {
    id: 'categories',
    label: 'Categories',
    icon: '▣',
    title: 'Categories',
    subtitle: 'Main categories and sub-categories for the storefront.',
  },
  {
    id: 'labels',
    label: 'Collections',
    icon: '◐',
    title: 'Collections',
    subtitle: 'Gradient collection cards shown on the landing page.',
  },
  {
    id: 'sizecharts',
    label: 'Size Charts',
    icon: '▤',
    title: 'Size Charts',
    subtitle: 'Default measurement chart attached to products.',
  },
  {
    id: 'banners',
    label: 'Banners',
    icon: '▥',
    title: 'Banners',
    subtitle: 'Hero / landing banner images for the storefront.',
  },
  {
    id: 'testimonials',
    label: 'Testimonials',
    icon: '✩',
    title: 'Testimonials',
    subtitle: 'Customer quotes for the landing page.',
  },
  {
    id: 'contacts',
    label: 'Messages',
    icon: '✉',
    title: 'Messages',
    subtitle: 'Enquiries submitted from the contact form.',
  },
];

export function getAdminSection(hash) {
  const id = (hash || '#intro').replace(/^#/, '') || 'intro';
  return ADMIN_SECTIONS.find((s) => s.id === id) || ADMIN_SECTIONS[0];
}
